import { belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Day } from 'lumen/models';
import ShortTermRentalRate from 'lumen/models/short-term-rental-rate';

export default class CompareShortTermRentalRate extends ShortTermRentalRate {
  // @ts-expect-error: Class inheritance
  [Type] = 'compare-short-term-rental-rate' as const;

  @belongsTo('day', { async: true, inverse: 'compareShortTermRentalRates' })
  declare day: Day;

  modelName = 'compare-short-term-rental-rate';
}
